<template>
  <div>
    <div class="custom-tab-body-cont hasfooter flex-column" style="overflow:hidden">
      <b-row class="p-3">
        <b-col class="d-flex">
          <span class="mode-group-label">Install from</span>
          <b-form-group class="mode-group px-2">
            <b-form-radio-group button-variant="outline-custom" buttons v-model="installer" :options="options" class="active"></b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col class="text-right relative search-input-container" v-if="installer==='wprepoinstaller'">
          <b-input class="mb-2 mr-sm-2 mb-sm-0 search-input" v-model="searchText" debounce="500" id="search_text" type="text" placeholder="Search sites" />
          <div class="search-icon-container">
            <magnifier-icon class="icon-default search-icon"></magnifier-icon>
          </div>
        </b-col>
      </b-row>
      <b-row class="full-height" style="min-height:1px">
        <b-col class="full-height">
          <component :is="installer" :sites="sites" :type="type" @onInstall="install" @gotoWpRepo="gotoWpRepo" :searchText="searchText" @addFavorite="addFavorite"></component>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import favoriteinstaller from './FavoriteInstaller';
import wprepoinstaller from './WpRepoInstaller';
import mycomputerinstaller from './MyComputerInstaller';
import urlinstaller from './URLInstaller';
import utilsMixin from '../../mixins/utils';
import MagnifierIcon from '../../assets/lens.svg';
export default {
  name: 'pluginthemesinstaller',
  props: ['type', 'sites'],
  mixins: [utilsMixin],
  components: {
    favoriteinstaller,
    wprepoinstaller,
    mycomputerinstaller,
    urlinstaller,
    MagnifierIcon
  },
  data() {
    return {
      installer: 'favoriteinstaller',
      searchText: '',
      options: [
        { text: 'My favorites', value: 'favoriteinstaller' },
        { text: 'WP Repository', value: 'wprepoinstaller' },
        { text: 'My Computer', value: 'mycomputerinstaller' },
        { text: 'URL', value: 'urlinstaller' }
      ]
    };
  },
  methods: {
    install(event) {
      let payload = {};
      payload.action = `install${this.capitalizeFirstLetter(event.type)}`;
      let selectedItems = event.selectedItems;
      let selectedSiteIds = this.sites;
      payload.args = {};
      payload.args.params = {};
      payload.args.siteIDs = selectedSiteIds;
      let paramsArray = [];
      _.each(selectedItems, selectedItem => {
        paramsArray.push(selectedItem);
      });
      payload.args.params[this.type] = paramsArray;
      if (event.activate) {
        payload.args.params['activate'] = event.activate;
      }
      if (event.clearDestination) {
        payload.args.params['clearDestination'] = event.clearDestination;
      }
      payload.requiredData = {};
      payload.requiredData['getPluginsAndThemesV3'] = 1;
      if (event.addFavourites) {
        payload.requiredData.addFavourites = event.addFavourites;
      }
      this.$store
        .dispatch('sendAction', payload)
        .then(() => {
          
          this.$emit('close');
        })
        .catch(err => {
          
        });
    },
    gotoWpRepo() {
      this.installer = 'wprepoinstaller';
    },
    addFavorite(event) {
      let payload = {};
      payload.requiredData = {
        addFavourites: event,
        getFavouritesPluginsAndThemesV3: 1
      };
      this.$store
        .dispatch('sendAction', payload)
        .then(response => {
          this.$store.commit(
            'SET_FAVORITES',
            response.data.getFavouritesPluginsAndThemesV3
          );
          
        })
        .catch(err => {
          
        });
    }
  }
};
</script>

<style scoped>
</style>
